import React from 'react';
import useAnalyticsEventTracker from './useAnalyticsEventTracker';
import './css/PhoneCallButton.css';

function PhoneCallButton() {
  const gaEventTracker = useAnalyticsEventTracker('Contact');

  return (
    <a
      href="tel:+919755565810"
      className="contact-button phone-button"
      title="Call Murtaza"
      aria-label="Call Murtaza"
      onClick={() => gaEventTracker('click', 'Phone Button', 'Phone')}
    >
      <i className="fas fa-phone"></i>
    </a>
  );
}

export default PhoneCallButton;
